(function () {
  'use strict';

  /* ---------- Bundle builder pricing ----------
     The "Build Your Bundle" block hard-coded old prices (2 scrubs = PKR 2,950),
     which showed a NEGATIVE saving and never matched the cart. The cart price
     comes from the store's automatic discounts, so the builder now shows the
     exact same numbers:
       - any 2 scrubs: Rs 399 off the pair (= Rs 2,399 for two Rs 1,399 scrubs)
       - any 2 mists: 10% off
       - 1 scrub + 1 mist: no bundle discount (shown as regular price)
     Keep these in sync with Shopify admin > Discounts. */
  var SCRUB_PAIR_OFF = 39900;   // cents
  var MIST_PAIR_RATE = 0.10;

  function rupees(cents) {
    var hasPaisa = cents % 100 !== 0;
    return 'Rs ' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: hasPaisa ? 2 : 0,
      maximumFractionDigits: hasPaisa ? 2 : 0
    });
  }

  function patchBundleBuilders() {
    var tags = {};
    document.querySelectorAll('[class^="ai-bundle-builder-"]').forEach(function (el) {
      tags[el.tagName.toLowerCase()] = true;
    });
    Object.keys(tags).forEach(function (tag) {
      if (tag.indexOf('bundle-builder-') !== 0) return;
      var Ctor = customElements.get(tag);
      if (!Ctor || Ctor.prototype.__tbsPatched) return;
      var proto = Ctor.prototype;
      proto.__tbsPatched = true;

      proto.formatMoney = rupees;

      proto.calculateBundlePrice = function () {
        var total = this.selectedProducts.reduce(function (s, p) { return s + p.price; }, 0);
        var types = this.selectedProducts.map(function (p) { return p.type; });
        var scrubs = types.filter(function (t) { return t === 'scrub'; }).length;
        var mists = types.filter(function (t) { return t === 'mist'; }).length;
        if (scrubs === 2) return Math.max(total - SCRUB_PAIR_OFF, 0);
        if (mists === 2) return Math.round(total * (1 - MIST_PAIR_RATE));
        return total;
      };

      var originalUpdate = proto.updateSummary;
      proto.updateSummary = function () {
        originalUpdate.call(this);
        if (this.selectedProducts.length === 0) {
          this.bundlePriceElement.textContent = 'From Rs 2,399';
          return;
        }
        if (this.selectedProducts.length !== 2) return;
        var total = this.selectedProducts.reduce(function (s, p) { return s + p.price; }, 0);
        var price = this.calculateBundlePrice();
        var saving = total - price;
        if (saving > 0) {
          this.savingsElement.textContent = 'You save ' + rupees(saving) + ' + free delivery';
        } else {
          this.savingsElement.textContent = 'Bundle price applies to 2 scrubs or 2 mists';
        }
      };

      document.querySelectorAll(tag).forEach(function (el) {
        if (el.bundlePriceElement && el.selectedProducts && el.selectedProducts.length === 0) {
          el.bundlePriceElement.textContent = 'From Rs 2,399';
        }
      });
    });
  }

  /* ---------- WhatsApp bubble vs bundle summary ----------
     Hide the WhatsApp chat bubble while the bundle builder's summary/button
     is on screen, so it can't cover "Add Bundle to Cart" on phones. */
  function watchBundleSummary() {
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('[class*="ai-bundle-builder__summary-"]');
    if (!targets.length) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target);
      });
      document.documentElement.classList.toggle('tbs-hide-wa', visible.size > 0 && window.innerWidth < 750);
    });
    targets.forEach(function (t) { io.observe(t); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchBundleBuilders();
    watchBundleSummary();
  });
})();
